import React from 'react';
import PropTypes from 'prop-types';
import AgeRestrictionsMatrix from './AgeRestrictionsMatrix';

const AgeRestrictionsSettings = ({
  teamId,
  csrfToken,
  initialSettings,
  venueOwnerships,
  initialVenueAgeRestrictions,
}) => (
  <AgeRestrictionsMatrix
    teamId={teamId}
    csrfToken={csrfToken}
    initialSettings={initialSettings || []}
    venueOwnerships={venueOwnerships || []}
    initialVenueAgeRestrictions={initialVenueAgeRestrictions || {}}
  />
);

AgeRestrictionsSettings.propTypes = {
  teamId: PropTypes.number.isRequired,
  csrfToken: PropTypes.string.isRequired,
  initialSettings: PropTypes.array,
  venueOwnerships: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number.isRequired, name: PropTypes.string.isRequired })
  ),
  initialVenueAgeRestrictions: PropTypes.object,
};

export default AgeRestrictionsSettings;
